// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2EzFvdEhBGOf1Ogc5ReGNA","CardHeader":"Kf8j3XtKkoO8VATsYqe1E","CardBody":"_3BQUT5eCHRkE1bmGKqDfDT","Media":"wr3jNGYDKPM-Sce8g86KT","MediaIcon":"_1RlK3QdIOycWzD-cs-PXsc","MediaBody":"FtfQ4n8jABQq-FCaS3uzK","MediaMore":"_1S2iGHxt8IMkqziNvugDUT","Desc":"_265Hn94UfjApopmEW0eOuI","Link":"_14A6qr_sZDJ6ecvpNhUWKn","Icon":"rLts16d9D6gspl0OScCIQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PaymentsTotalToday/styles.module.css
// module id = 561
// module chunks = 0